module.exports = __webpack_public_path__ + "static/project4-d5a93b06deaa95945fa0bbd4f63538cd.jpg";